import React from "react";
import "../style/welcome.css";
function Welcome() {
  return (
    <div className="welcomeContainer">
      <div className="titleContainer">
        <h2>Type the name of your city</h2>
        <h1>to see weather forecast</h1>
      </div>
      <div className="circleContainer">
        <div className="circle one"></div>
        <div className="circle two"></div>
        <div className="circle three"></div>
      </div>
    </div>
  );
}

export default Welcome;
